import React, { Fragment, useEffect, useState } from "react";
import Emailpng from "../../assets/utils/images/Intagration image/mail.png"
import cx from "classnames";
import { Button, Row, Col} from "reactstrap";
import { cardData } from "./Constants";
import requestApiService from "../../services/requestApi.service";
import ShowIntegrationInfo from "./ShowIntDetails.js";


const Email = (props) => {
    let {isInstalation,buttonValue,unInstall,name} = props;   
    const [connectionvalue,setConnectionValues] = useState([]);
    const [isConnected, setConnectionStatus] = useState([]);
    const [accountInfo, setAccountInfo] = useState([]);
    const [carddata,setData] = useState(cardData);
    let key = '';
    let foundData = carddata.find((data) => data.name === "email");
    if (foundData) {
     key = foundData.component.button.key;
    }    

    useEffect(() => {
        (async () => {
            await fetchEmailAccountDetails();
        })();
        return () => {
        };
    }, [buttonValue]);

    const fetchEmailAccountDetails = async () => {
        let params = {
            ENTITY: "AIPROCESSOR",
            OPERATION: "LOAD_INTEGRATIONS",
            TYPE: "Email"
        }
        let response = await requestApiService.processServerRequest(params);
        if (response.issuccess) {
            let integrationInfo = response.data;
            if (integrationInfo.length > 0) {
                setConnectionStatus(true);
                const connectedInfo = JSON.parse(integrationInfo[0][2] || "{}");
                const { name,password,url,port,protocol,sender,fromaddress } = connectedInfo.data || {}; 
                let IntegrationAccountInfo = [
                    { 
                        type : "id",
                        id : integrationInfo[0][0]
                    },{
                        type: "text",
                        label: "Name",
                        value: name,
                    },{
                        type: "password",
                        label: "Password",
                        value: password,
                    },{
                        type: "text",
                        label: "Host",
                        value: url,
                    },{
                        type: "text",
                        label: "Port",
                        value: port,
                    },{
                        type: "text",
                        label: "Protocol",
                        value: protocol,
                    },{
                        type: "text",
                        label: "Sender",
                        value: sender,
                    },{
                        type: "text",
                        label: "Fromaddress",
                        value: fromaddress,
                    },
                ];
                setAccountInfo(IntegrationAccountInfo);
            } else {
                setAccountInfo([]);
                setConnectionStatus(false);
            }
        }
    }

    const onOpenModal = (type,openModule = false) => {
            isInstalation(type,openModule,foundData.name,"Communication");
    }

    const integrationHeadData = {
        name: "Email",
        tag: "Communication",
        image: Emailpng, // Replace with your actual image import
        installButtonText: "Install App",
        uninstallButtonText: "Uninstall App",
        testConnectionText: "Test Connection",
    };
    
    const integrationContent = [
        {
            heading: "Website",
            subheading: "https://www.gmail.com/",
            type: "url"
        },
        {
            heading: "Overview",
            subheading: "Connect your SMTP email service to automatically send email notifications after each AI-powered call. Whether it’s to the caller or a specific email address, keep everyone informed in real time.",
            type: "text"
        },
        {
            heading: "Key Benefits",
            subheading: [
                {
                    description: "Automatically send post-call emails with call summaries or follow-ups.",
                    // description: "Free up valuable time by allowing our AI-powered agents to take over appointment bookings and rescheduling tasks. OneInbox integrates with Cal.com to check real-time availability and instantly confirm bookings on your behalf."
                },
                {
                    description: "Deliver emails to the caller or route them to a designated inbox.",
                    // description: "Offer round-the-clock booking and scheduling support, ensuring customers can book appointments at any time."
                },
                {
                    description: "Use your custom domain and SMTP credentials for professional delivery.",
                    // description: "Provide a smoother, faster experience by offering 24/7 booking capabilities. OneInbox AI agents can assist customers anytime, checking availability and scheduling appointments within seconds."
                },
                {
                    description: "Ensure reliable delivery and full control over your email content and sender settings.",
                    // description: "All appointments are automatically synced with your Cal.com calendar, ensuring you and your team have the latest information without needing manual updates."
                }
            ],
            type: "list"
        }
    ];
    

    return (
        <Fragment>
            <div className="agent-details"> 
                <Fragment>
                        <ShowIntegrationInfo
                            keyname={name}
                            headData={integrationHeadData}
                            integrationData={integrationContent}
                            isInstalled={buttonValue.includes(name)}
                            isConnected={isConnected}
                            accountInfo={accountInfo}
                            onInstall={onOpenModal}
                            onRemove={unInstall}
                        />
                </Fragment>
            </div> 
       </Fragment>
    )

    /* return (
        <Fragment>
            <div className="agent-details">
                {
                    <Fragment>
                        <div className="ghl-heading">
                            <div className="ghl-details">
                            <Row>
                                <Col md={1}>
                                <span className="card-image-status">
                                    <img src={Emailpng} className="intagration-card-detail-img"/>
                                </span>
                                </Col>
                                <Col md={7} className="p-1">
                                <span className="heading">
                                    Email
                                </span>
                                <span className="tag">
                                    Communication
                                </span>
                                </Col>
                                <Col md={4} className="d-flex justify-content-center">
                                {!buttonValue.includes(foundData.name) ? (<Button
                                    name={"cancel"}
                                    className={cx("badge-theme badge-btn m-4")}
                                    onClick={(e) => { onOpenModal(key,true) }}
                                >
                                    <i class="fi fi-br-plus-small"></i>
                                    {<span>{"Install App"}</span>}
                                </Button>):(
                                    <div>
                                    <Button name={"cancel"} className={cx("theme-bg-g badge-btn")} color="dark" onClick={(e) => { onOpenModal('test_connect',true) }}>
                                        <i class="fi fi-rs-plug-connection"></i> {/* fi fi-br-plus-small *
                                        {<span>{"Test Connection"}</span>}
                                    </Button>
                                    <Button
                                    name={"cancel"}
                                    className={cx("badge-theme badge-btn m-1")}
                                    onClick={(e) => { unInstall(key) }}
                                >
                                    <i class="fi fi-br-plus-small"></i>
                                    {<span>{"Uninstall App"}</span>}
                                </Button> </div>)}
                                </Col>
                                </Row>          
                            </div>
                        </div>
                        <div className="card-fields">
                            <span className="field-name">Website</span>
                            <span>
                            <a href="https://www.gmail.com/" target="_blank">https://www.gmail.com/</a>
                            </span>
                        </div>
                        <div className="card-fields">
                            <span className="field-name">Overview</span>
                            <span className="subheading">The Voicemetrics integration with Cal.com transforms scheduling into an effortless experience for your team and customers. By combining OneInbox’s advanced AI calling capabilities with Cal.com’s flexible calendar management, businesses can fully automate appointment booking, rescheduling, and reminders. This integration lets you simplify workflows and increase efficiency by enabling AI agents to handle scheduling tasks seamlessly, even in high-volume scenarios.'</span>
                        </div>
                        <div className="card-fields">
                            <span className="field-name">Key Benefits</span>
                            <span className="subheading ver-2px">
                                <span className="col-pri"> Automated Scheduling and Rescheduling </span>
                                Free up valuable time by allowing our AI-powered agents to take over appointment bookings and rescheduling tasks. OneInbox integrates with Cal.com to check real-time availability and instantly confirm bookings on your behalf.                                
                                <span className="col-pri"> Improved Accessibility </span>
                                Offer round-the-clock booking and scheduling support, ensuring customers can book appointments at any time.
                                <span className="col-pri"> Enhanced Customer Experience </span>
                                Provide a smoother, faster experience by offering 24/7 booking capabilities. OneInbox AI agents can assist customers anytime, checking availability and scheduling appointments within seconds.                            
                                </span>
                                <span className="col-pri"> Real-Time Syncing </span>
                                All appointments are automatically synced with your Cal.com calendar, ensuring you and your team have the latest information without needing manual updates.
                        </div>
                    </Fragment>
                }
            </div>
        </Fragment>
        
    ) */
}

export default Email;